


































import VueOptions from '@utils/VueOptions'

settings =
  name: 'AudienceListingPhysicalSigns'

  vue:
    props: ['audienceListing', 'options']

    computed:
      physicalSigns: -> @audienceListing.physical_signs || {}
      campaignPhysicalSigns: -> @options?.campaign?.creatives?.product_sampling?[0]?.activation_snapshot?.physical_signs || {}

export default VueOptions.vue settings
